import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiResListsType } from 'global-services/api/OhsApiModels';
import { OhsIncidentFilterPayload, OhsIncidentSearchMain } from 'incident/models/OhsIncidentModels';
import OhsIncidentRecord from 'incident/OhsIncidentRecord';
// eslint-disable-next-line import/no-cycle
import { getIncidentLists, getIncidentSearchLists } from 'incident/OhsIncidentServices';
import { OhsUser } from 'user/OhsUser';
import OhsUserLocalServices from 'user/OhsUserLocalServices';

export const incidentListsRPC = async (
  payload: OhsIncidentFilterPayload | OhsIncidentSearchMain,
  hasSearch: boolean = false
): Promise<any> => {
  const user = OhsUserLocalServices.getLocalOhsUser() as OhsUser;
  const userTier = user?.tierNum ?? 0;

  if (
    userTier &&
    (userTier === 3 || userTier === 4 || userTier === 5) &&
    user?.configs.incident?.PERMISSIONS.view
  ) {
    const response = hasSearch
      ? await getIncidentSearchLists(payload as any)
      : await getIncidentLists(payload as OhsIncidentFilterPayload);
    return response;
  }
  return null;
};

export const fetchIncidentListsAsync = createAsyncThunk<
  {
    list: ApiResListsType<OhsIncidentRecord[]> | null;
    count: ApiResListsType<OhsIncidentRecord[]> | null;
  },
  {
    list: OhsIncidentFilterPayload | OhsIncidentSearchMain;
    count: OhsIncidentFilterPayload | OhsIncidentSearchMain;
    hasSearch: boolean;
  }
>('incident/fetchIncidentList', async (payload, thunkAPI) => {
  const getListData = (data: OhsIncidentFilterPayload | any) =>
    incidentListsRPC(data, payload.hasSearch);

  try {
    const [list, count] = await Promise.all([
      getListData(payload.list),
      getListData(payload.count),
    ]);

    return { list, count };
  } catch (err: any) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
